import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { io } from 'socket.io-client';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  url: string = environment.urlWebsocket;
  websocketConnection(): any{ 
    return io(`${this.url}`, {
      reconnectionAttempts: 5,
      reconnectionDelay: 15000,
      reconnectionDelayMax: 60000,
      randomizationFactor: 0.1,
      reconnection: true,
      transports: ['websocket', 'polling'],
      path: '/tolifecloud-api-websocket-panel/socket.io',
    });
  }
}

/**
 * How to use websocket feature
 * 
 * 
 * const socket = this.websocketService.websocketConnection('clientPanel', `panelId-${this.panelId}`);
 * 
 * socket.disconnect (boolean que identifica se a conexão ainda existe);
 * 
 * socket.on('clientPanel', function(res){
 *  //do something
 * });
 */
